import React from 'react';

const AsyncReportPage = React.lazy(() => import('./GenerateContainer'));

export const ReportPage = () => {
  return <AsyncReportPage />;
};
